import {isElement} from '@mantine/utils';
import $ from 'jquery';
import React from 'react';

import {assertAndContinue} from 'Asserts';
import {isBrowser} from 'lib/Browser';

export interface ClickOutWrapperProps {
  /**
   * N.B.: `children` must be a single child element, not an array, not a fragment, that forwards or natively
   * accepts a ref.
   */
  children: React.ReactElement;
  shouldCloseOnInsideClick?: boolean;
  onClickOut: (e: MouseEvent) => void;
}

export default class ClickOutWrapper extends React.Component<ClickOutWrapperProps> {
  ref = React.createRef<HTMLElement>();

  static defaultProps = {
    shouldCloseOnInsideClick: false,
  };

  override componentDidMount(): void {
    if (isBrowser) {
      window.addEventListener('click', this.handleBodyClick, true);
    }
  }

  override componentWillUnmount(): void {
    if (isBrowser) {
      window.removeEventListener('click', this.handleBodyClick, true);
    }
  }

  private handleBodyClick = (e: MouseEvent): void => {
    const node = this.ref.current;
    if (!assertAndContinue(node != null, 'Expected component to be mounted')) {
      return;
    }
    const $node = $(node!);
    const inDOMNode = $(e.target!).closest($node).length > 0;
    if (this.props.shouldCloseOnInsideClick || !inDOMNode) {
      this.props.onClickOut(e);
    }
  };

  override render(): React.ReactNode {
    if (!isElement(this.props.children)) {
      throw new Error('ClickOutWrapper requires a single child element');
    }
    return React.cloneElement(this.props.children, {ref: this.ref});
  }
}
